export class DenouncedTraffic {
    get id() {
        return this.denouncedTrafficState.id;
    }
    get diligenceNumber() {
        return this.denouncedTrafficState.diligenceNumber;
    }
    get denouncedThirId() {
        return this.denouncedTrafficState.denouncedThirId;
    }
    get optionalPart() {
        return this.denouncedTrafficState.optionalPart;
    }
    get medicalHistory() {
        return this.denouncedTrafficState.medicalHistory;
    }
    get userId() {
        return this.denouncedTrafficState.userId;
    }
    set id(id) {
        this.denouncedTrafficState.id = id;
    }
    set diligenceNumber(diligenceNumber) {
        this.denouncedTrafficState.diligenceNumber = diligenceNumber;
    }
    set denouncedThirId(denouncedThirId) {
        this.denouncedTrafficState.denouncedThirId = denouncedThirId;
    }
    set optionalPart(optionalPart) {
        this.denouncedTrafficState.optionalPart = optionalPart;
    }
    set medicalHistory(medicalHistory) {
        this.denouncedTrafficState.medicalHistory = medicalHistory;
    }
    set userId(userId) {
        this.denouncedTrafficState.userId = userId;
    }
    constructor(denouncedTrafficState) {
        this.denouncedTrafficState = denouncedTrafficState;
    }
    getState() {
        return this.denouncedTrafficState;
    }
}
